import dayjs, { Dayjs } from "dayjs";

export function hasDatePassed(date: string) {
  const startDate = dayjs(date, "YYYY-MM-DD");

  const now = dayjs();

  // Calculate the difference in days
  const diffInDays = startDate.diff(now, "day");

  // Return true if the difference is greater than or equal to the given number of days
  return diffInDays >= 0;
}

export function formatToYYYYMMDD(rawValue: Dayjs) {
  return rawValue.format("YYYY-MM-DD");
}

export function formatToMMDDYYYY(rawValue) {
  // 1) Remove all non-digits
  const onlyDigits = rawValue.replace(/\D/g, "");

  // 2) Build up the formatted output in stages
  //    - First 2 digits => MM
  //    - Next 2 digits => DD
  //    - Last 4 digits => YYYY

  if (onlyDigits.length <= 2) {
    // 0..2 digits => just show them
    return onlyDigits;
  } else if (onlyDigits.length <= 4) {
    // 3..4 digits => MM - DD (partial if only 3)
    return onlyDigits.slice(0, 2) + "-" + onlyDigits.slice(2);
  } else if (onlyDigits.length <= 8) {
    // 5..8 digits => MM - DD - YYYY (partial if < 8)
    return onlyDigits.slice(0, 2) + "-" + onlyDigits.slice(2, 4) + "-" + onlyDigits.slice(4);
  } else {
    // More than 8 digits => ignore extras
    const clipped = onlyDigits.slice(0, 8);
    return clipped.slice(0, 2) + "-" + clipped.slice(2, 4) + "-" + clipped.slice(4);
  }
}

/**
 * Formats a date string into "DD/MM/YYYY"
 * @param date - ISO date string or any valid Day.js input
 * @returns formatted date string or "-" if invalid
 */
export const formatDate = (date: string | Date | null | undefined, format: string = "dd/mm/yyyy"): string => {
  if (!date) return "-";

  const parsed = dayjs(date);
  console.log("Parsed date:", parsed.format(format));

  return parsed.isValid() ? parsed.format(format) : "-";
};

export const formatDateTime = (date: string | Date | null | undefined, format: string = "dd/mm/yyyy"): string => {
  if (!date) return "-";
  const parsed = dayjs(date);
  return parsed.isValid() ? parsed.format(format) : "-";
};

export const downloadAnyFile = (blob: Blob | MediaSource, filename: string = "downloaded_file"): boolean => {
  try {
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `${filename}`;
    link.click();
    window.URL.revokeObjectURL(downloadUrl);
    return true;
  } catch (error) {
    console.error("Error downloading the file:", error);
    return false;
  }
};

export const extractFileName = (url: string) => {
  return url.split("/").at(-1) || "";
};

export const titleCase = (str: string | null | undefined) =>
  str
    ? str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";
